import { NextSeo } from 'next-seo';
import React from 'react';

import Footer from '../../components/Footer';
import SearchPage from 'components/search/SearchPage';
import pages from '../../config/pages';
import { SearchProvider } from 'contexts/SearchContext';
import { dehydrate, QueryClient, useQuery } from 'react-query';
import { fetchCategories } from 'data/fetchers';

export async function getStaticProps() {
    const queryClient = new QueryClient();
    await queryClient.prefetchQuery('categories', () => fetchCategories({}));

    return {
        props: {
            dehydratedState: dehydrate(queryClient)
        },
        revalidate: 60 * 60 * 12 // In seconds
    };
}

const IdeaListPage = () => {
    const { data: categories } = useQuery('categories', () => fetchCategories({}));
    return (
        <div className="single-page ideas">
            <NextSeo
                title={pages.ideas.title}
                description={pages.ideas.seo.description}
                openGraph={{
                    description: pages.ideas.seo.description,
                    title: pages.ideas.seo.title,
                    url: pages.ideas.seo.url
                }}
            />
            <SearchProvider categories={categories.data}>
                <SearchPage />
            </SearchProvider>
            <Footer />
        </div>
    );
};

export default IdeaListPage;
